module.exports = __webpack_public_path__ + "static/media/sun.e123bcf6.png";